import { Link } from '@tanstack/react-router';
import { useT } from '../../i18n.ts';

interface CrossLink {
  to: '/features/documents' | '/features/approvals' | '/features/ai';
  eyebrow: string;
  title: string;
  desc: string;
}

interface CrossLinksProps {
  links: CrossLink[];
}

export function CrossLinks({ links }: CrossLinksProps) {
  const t = useT();
  return (
    <div className="mkt-crosslinks">
      {links.map((link) => (
        <Link key={link.to} to={link.to} className="mkt-crosslink">
          <span className="mkt-crosslink-eyebrow">{link.eyebrow}</span>
          <span className="mkt-crosslink-title">{link.title}</span>
          <span className="mkt-crosslink-desc">{link.desc}</span>
          <span className="mkt-crosslink-cta">{t('marketing.crosslink.read-more')}</span>
        </Link>
      ))}
    </div>
  );
}
